<template>
  <div class="pro-icon-info">
    <div class="info-body">
      <p>{{ title ? title : $t('Информация о блоке') }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String
  },
}
</script>
